<template>
  <div class="package-list-wrapper">
    <div class="package-list-container">
      <div class="package-list-tips" v-if="showTips">
        <img :src="require('@/assets/images/warning.png')" alt="" class="package-list-tips-icon" />{{ tips }}
      </div>
      <div class="package-list-header">
        <div class="package-list-header-label">
          {{ $t('订购主体：') }}
        </div>
        <div class="package-list-header-subject">
          {{ mainInfo.name || '-' }}
        </div>
      </div>
      <div class="package-list-body">
        <div
          :class="['package-list-item', selectPackageId === item.packageId ? 'current' : '']"
          @click="select(item)"
          v-for="item in packageList"
          :key="item.packageId"
        >
          <div class="package-list-item-header">
            <span class="package-list-item-price">{{ item.price }}</span>
            <span class="package-list-item-unit">{{ $t('元') }}</span>
          </div>
          <div class="package-list-item-body">
            {{ item.packageName }}
          </div>
          <img v-if="selectPackageId === item.packageId" :src="require('@/assets/images/check@2x.png')" alt="" class="checked" />
        </div>
      </div>
    </div>
    <div class="package-list-footer">
      <div v-if="this.hidePay" class="hidePay-aside">{{ $t('暂不支持苹果手机支付，请用其他平台支付或联系服务商') }}</div>
      <em-button v-if="this.hidePay" block @click="contract">{{ $t('联系服务商') }}</em-button>
      <em-button @click="submit" v-else block>{{ $t('提交订单') }}</em-button>
    </div>
  </div>
</template>

<script>
import { $t, genUrlLang } from '@/locales'
import mainInfoMixin from './mixin'
import { getToken } from '@/plugins/token'
import realnameMixin from '@/mixins/realname'
import { goRealname, setRealNameRedirectUrl, setPageTitle, navigateTo } from '@esign/esign-plugin/lib/esign-jssdk'
import { sourceChannel, orderSourceMap } from '@esign/esign-client-jssdk'
import Vue from 'vue'
import { Button, Checkbox } from '@esign/esign-design-mobile'
import { mapState } from 'vuex'
Vue.use(Checkbox)
Vue.use(Button)
setPageTitle($t('订购'))
export default {
  name: 'PackageList',
  mixins: [mainInfoMixin, realnameMixin],
  data() {
    return {
      packageList: [],
      selectPackageId: null,
      enableBuySign: false, // 会员版本是否可以购买签署流量
      vipText: '',
      showTips: false,
    }
  },
  async created() {
    const loading = this.$toast.loading({
      message: $t('加载中...'),
      duration: 0,
    })
    try {
      await this.setMainInfo()
      this.getVipInfo()
      await this.getPackageList()
      this.$tsignData.track('product_window_page_display')
      this.calcPageInitTime()
      this.reportSourceChannel()
    } catch (error) {
      console.error(error)
    }
    loading.clear()
  },
  computed: {
    ...mapState('user', ['userInfo']),
    client() {
      return this.$route.query.client || 'H5'
    },
    hidePay() {
      return this.$route.query.hidePay
    },
    tips() {
      return this.enableBuySign
        ? $t('以下合同均自购买日起一年内有效')
        : $t('当前企业的版本为{slot}，仅支持签署合同/文件。若要发起合同，请订阅购买会员版本。', { slot: this.vipText })
    },
    tenantId() {
      return this.orgId || (this.mainInfo.base ? this.mainInfo.base.ouid : '')
    },
  },
  methods: {
    /** 上传计费业务埋点 */
    reportSourceChannel() {
      const personOid = (this.userInfo && this.userInfo.base.ouid) || '-'
      const personGid = (this.userInfo && this.userInfo.base.guid) || '-'
      const data = {
        commodity_number: '-',
        commodity_name: '-',
        commodity_id: '-',
        user_type: this.orgId ? '企业' : '个人',
        oid: this.orgId ? this.mainInfo.base.ouid : personOid,
        gid: this.orgId ? this.mainInfo.base.guid : personGid,
        pay_amount: '-',
        geren_oid: personOid,
        geren_gid: personGid,
        order_source: orderSourceMap[sourceChannel] || 'other',
        order_id: '-',
      }
      this.$tsignData.track('to_select_commodity', data)
    },
    async getVipInfo() {
      try {
        if (!this.tenantId) return
        const { data } = await this.$EHttp.api({
          url: `webserver/v2/saas-common/vipmanage/${this.tenantId}/vip?withFuncs=true`,
          method: 'get',
          headers: {
            'X-Tsign-Open-Tenant-Id': this.tenantId,
          },
        })
        console.log(data)
        const item = data.functions.find((item) => item.code === 'buy_sign')
        this.vipText = data.vipName
        this.enableBuySign = item && item.enable
        // 只有企业版本不能订购套餐并且是企业空间下才展示提示语
        if (!this.enableBuySign && this.orgId) {
          this.showTips = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    /* eslint-disable camelcase */
    calcPageInitTime() {
      // 防止重复上报
      if (sessionStorage.getItem('trackPackagePageInitTime')) return
      const { query } = this.$route
      const { event_name, start_time, client_type } = query
      if (event_name && start_time && client_type) {
        const time_consume = Date.now() - Number(start_time)
        // 异常数据不上报
        if (time_consume < 0 || time_consume > 30000) return
        this.$tsignData.track(event_name, {
          client_type,
          init_scene: $t('购买'),
          page_route: window.location.href,
          time_consume,
        })
        sessionStorage.setItem('trackPackagePageInitTime', 'true')
      }
    },
    select(item) {
      this.selectPackageId = item.packageId
    },
    async getPackageList() {
      const { data } = await this.$EHttp.api({
        url: `webserver/v1/saas-common/bills/saas-commodities`,
        method: 'get',
        headers: {
          'X-Tsign-Client-Id': this.client,
          // 不传orgId默认给个人空间买套餐
          'X-Tsign-Open-Tenant-Id': this.tenantId,
        },
      })
      const addedCommodities = data.addedCommodities || []
      const signCommodities = data.signCommodities || []
      const vipCommodities = data.vipCommodities || []
      const arr = [].concat(vipCommodities, signCommodities, addedCommodities)
      // eslint-disable-next-line no-unused-expressions
      arr.forEach((item) => {
        if (item.packageInfoList && item.packageInfoList.length) {
          this.packageList = this.packageList.concat(item.packageInfoList)
        }
      })
      if (this.packageList.length) {
        this.selectPackageId = this.packageList[0].packageId
      }
    },
    async getOrderListUrl() {
      const { data } = await this.$EHttp.api({
        url: `webserver/v1/accounts/sys_accountId/orderListUrl?token=${getToken()}`,
        method: 'get',
        headers: {
          'X-Tsign-Client-Id': this.client,
          'X-Tsign-Open-Tenant-Id': this.orgId || '',
        },
      })

      return data.url
    },
    async submit() {
      this.$tsignData.track('product_window_page_checkout_button_click')

      // 若未实名，则提示弹框
      if (!this.mainInfo.realnameStatus) {
        this.$tsignData.track('order_out_real_name')
        const confirmFlag = await this.showRealnameWarn('', this.orgId)
        if (!confirmFlag) return false
      }

      // 先获取订单列表的url
      let urlData = await this.getOrderListUrl()
      urlData += urlData.indexOf('?') > 0 ? '&from=jifei' : '?from=jifei'
      // 生成带语言的链接
      urlData = genUrlLang(urlData)
      if (this.$route.query.openId) urlData += `&openId=${this.$route.query.openId}`
      const redirectUrl = this.$route.query.returnUrl ? encodeURIComponent(this.$route.query.returnUrl) : encodeURIComponent(urlData)
      const selectPackage = this.packageList.find((item) => item.packageId === this.selectPackageId)
      const source_channel = Number(this.$route.query.source_channel) || sourceChannel
      // 生成计费url
      let jifeiUrl = `${process.env.VUE_APP_ORDER_URL}/MyOrder/h5Confirm?commodityId=${selectPackage.commodityId}&menuId=${selectPackage.packageId}&returnUrl=${redirectUrl}&client=${this.client}`
      source_channel && (jifeiUrl += `&source_channel=${source_channel}`)
      jifeiUrl += this.orgId ? `&ctype=1&organ=${this.orgId}` : '&ctype=0'
      if (this.$route.query.token) jifeiUrl += `&token=${this.$route.query.token}`
      if (this.$route.query.openId) jifeiUrl += `&openId=${this.$route.query.openId}`
      console.log('url-----------', jifeiUrl)

      // 如果已实名，则直接跳计费
      if (this.mainInfo.realnameStatus) return (window.location.href = jifeiUrl)
      const url11 = await setRealNameRedirectUrl(jifeiUrl)
      console.log('url11-----', url11)
      const realnameUrl = await this.toRealNameForAllPlatform(url11, this.orgId, false)

      // 跳实名
      goRealname(realnameUrl, this.client)
    },
    contract() {
      navigateTo({
        path: 'qiyu',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.package-list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .package-list-container {
    flex: 1;
    overflow-y: auto;
    background: #fff;
    .package-list-tips {
      display: flex;
      align-items: center;
      padding: 28px;
      font-size: 30px;
      color: #333333;
      line-height: 44px;
      background-color: #fff6e5;
      .package-list-tips-icon {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
  }
  .package-list-header {
    display: flex;
    padding: 32px 32px 48px;
    font-size: 32px;
    background: #fff;
    .package-list-header-label {
      line-height: 52px;
      color: #999;
      white-space: nowrap;
    }
    .package-list-header-subject {
      color: #333;
      line-height: 52px;
      word-break: break-all;
    }
  }
  .package-list-body {
    padding: 0 32px;
  }
  .package-list-item {
    position: relative;
    border: 1px solid #e5e6eb;
    background-color: #f7f8fa;
    padding: 32px 48px;
    margin-bottom: 32px;
    border-radius: 16px;
    &.current {
      border-color: #e34d59;
      background-color: #ffece3;
    }
    .checked {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 68px;
      height: 56px;
    }
    .package-list-item-header {
      display: flex;
      align-items: center;
      height: 78px;
      .package-list-item-price {
        font-size: 56px;
        line-height: 1;
        font-weight: 500;
        color: #333;
      }
      .package-list-item-unit {
        font-size: 32px;
        color: #333;
        font-weight: 500;
        line-height: 1;
        margin-left: 8px;
      }
    }
    .package-list-item-body {
      color: #666;
      font-size: 30px;
      line-height: 40px;
      word-break: break-all;
    }
  }
  .package-list-footer {
    flex-shrink: 0;
    padding: 24px;
    background: #fff;
    // .package-list-agreement {
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   height: 40px;
    //   font-size: 28px;
    //   color: #666;
    //   margin-bottom: 16px;
    //   line-height: 40px;
    //   /deep/ .em-checkbox__label {
    //     line-height: 40px;
    //     font-size: 28px;
    //   }
    //   span {
    //     color: #1063F1;
    //   }
    // }
    .hidePay-aside {
      width: 100%;
      font-size: 24px;
      color: #666666;
      line-height: 36px;
      text-align: center;
      margin-bottom: 24px;
    }
  }
}
</style>
